// 注册全局指令
import longpress from "./modules/longpress";
const directives = {
  longpress,
};

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key]);
    });
  },
};
